import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { tambahUser, getAllClient } from "stores";
import { useDispatch, useSelector } from "react-redux";
import { getAllUser } from "stores";
import { editStatusUser } from "stores";

function ListUser() {
  const dispatch = useDispatch();
  const storeClient = useSelector((state) => state.clientReducer);
  const user = useSelector((state) => state.userReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [pilihJabatan, setPilihJabatan] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [listUser, setListUser] = React.useState([]);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [idUser, setIdUser] = React.useState("");
  const [idClient, setIdClient] = React.useState("");
  const [modalUser, setModalUser] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [hoverBatal, setHoverBatal] = React.useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const submitUser = () => {
    tambahUser({
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            showConfirmButton: false,
            title: response.data.message,
            timer: 1000,
          });
          handleModalClose();
          getAllUser(dispatch);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const handleModalClose = () => {
    setModalUser(false);
    setPilihClient(null);
    setPilihJabatan(null);
    setIdClient("");
    setPilihJabatan("");
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusUser({
      idUser: idUser,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllUser(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  // const submitEdit = () => {
  //   Swal.fire({
  //     title: "Tunggu ...",
  //     didOpen() {
  //       Swal.showLoading();
  //     },
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //     allowEnterKey: false,
  //   });
  //   if (nama === "" || nopeg === "" || pilihClient === "") {
  //   } else {
  //     tambahUser({
  //       nama: nama,
  //       nopeg: nopeg,
  //       role: role,
  //       idClient: idClient,
  //     }).then((response) => {
  //       console.log(response);
  //       if (response === 200) {
  //         Swal.close();
  //         setModalPenempatan(false);
  //         setIdClient("");
  //         setPilihClient("");
  //       }
  //     });
  //   }
  // };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  React.useEffect(() => {
    getAllUser(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  React.useEffect(() => {
    let tmp =
      user.listUser &&
      user.listUser.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {val.role !== "super admin" ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Status Pengguna</Tooltip>}
                >
                  <Button
                    className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "10px",
                      backgroundColor: "#76CD26", // Hijau konsisten
                      border: "none",
                      color: "white",
                      transition: "all 0.2s ease",
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
                    onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                    onClick={() => {
                      setIdUser(val._id);
                      setModalEdit(!modalEdit);
                    }}
                  >
                    <i
                      className="fas fa-user-edit"
                      style={{ fontSize: "16px" }}
                    ></i>
                  </Button>
                </OverlayTrigger>
              ) : (
                <span
                  className="text-muted font-italic"
                  style={{ fontSize: "13px" }}
                >
                  <i className="fas fa-lock mr-1"></i> No Action
                </span>
              )}
            </div>
          ),
        };
      });
    setListUser(tmp);
  }, [user.listUser]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    header: {
      style: { minHeight: "56px" },
    },
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF", // Warna identitas AM
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar data tidak sesak
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
      },
    },
  };

  const colUser = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Username",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.role === "admin" ? "Admin" : "Client"),
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      selector: (row) => (row.penempatan ? row.penempatan : "-"),
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      selector: (row) => row.action,
    },
  ];

  return (
    <>
      <Modal
        size="md" // Ukuran medium lebih pas untuk satu input saja
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }} // Efek blur background yang Anda inginkan
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />

        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          {/* BAGIAN HEADER ICON TENGAH */}
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-shield fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Edit Status Pengguna
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Silahkan perbarui status aktifasi akun ini
            </p>
          </div>

          <Form className="form">
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
              }}
            >
              <Card.Body className="p-4">
                <Row>
                  <Col md="12" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-info-circle mr-2 text-primary"></i>{" "}
                        Status Akun
                      </label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="singleSelect"
                        value={status}
                        onChange={(selectedOption) => setStatus(selectedOption)}
                        options={[
                          { value: "true", label: "Aktif" },
                          { value: "false", label: "Tidak Aktif" },
                        ]}
                        placeholder="Pilih Status..."
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="mt-2">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#1D3557",
                      boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                      borderRadius: "15px",
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                    onClick={checkStatus}
                  >
                    <i className="fas fa-check-circle mr-2"></i> SIMPAN
                    PERUBAHAN
                  </Button>
                  <Button
                    variant="link"
                    className="btn-block mt-2 font-weight-bold"
                    style={{
                      textDecoration: "none",
                      color: "#6c757d",
                      transition: "all 0.2s ease-in-out",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setStatus("");
                      setModalEdit(false);
                    }}
                  >
                    BATALKAN
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalUser}
        onHide={() => {
          handleModalClose();
          setModalUser(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />

        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          {/* HEADER SECTION DENGAN ICON BESAR */}
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-plus fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Tambah Pengguna Baru
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Silahkan isi data kredensial untuk pengguna baru
            </p>
          </div>

          <Form className="form">
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
              }}
            >
              <Card.Body className="p-4">
                <Row>
                  {/* NAMA USER */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-id-card mr-2 text-primary"></i>{" "}
                        Nama Lengkap
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        type="text"
                        placeholder="Masukkan Nama"
                        style={{
                          borderRadius: "12px",
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                        onChange={(e) => setNama(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  {/* USERNAME */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-user-circle mr-2 text-primary"></i>{" "}
                        Username (Nopeg)
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        type="text"
                        placeholder="Masukkan Username"
                        style={{
                          borderRadius: "12px",
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                        onChange={(e) => setNopeg(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  {/* JABATAN */}
                  <Col md="6" className="mb-4">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-briefcase mr-2 text-primary"></i>{" "}
                        Jabatan / Role
                      </label>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={pilihJabatan}
                        onChange={(value) => {
                          setRole(value.value);
                          setPilihJabatan(value);
                        }}
                        options={[
                          { value: "admin", label: "Admin" },
                          { value: "client", label: "Client" },
                        ]}
                        placeholder="Pilih Role"
                      />
                    </Form.Group>
                  </Col>

                  {/* CLIENT (Jika Super Admin) */}
                  {auth.role === "super admin" && (
                    <Col md="6" className="mb-4">
                      <Form.Group>
                        <label
                          style={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: "#475569",
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          <i className="fas fa-building mr-2 text-primary"></i>{" "}
                          Pilih Client
                        </label>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClient(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>

                <div className="mt-4">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#1D3557",
                      boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                      borderRadius: "15px",
                      fontWeight: "800",
                      fontSize: "16px",
                    }}
                    onClick={submitUser}
                  >
                    <i className="fas fa-save mr-2"></i> SIMPAN DATA USER
                  </Button>
                  <Button
                    variant="link"
                    className="btn-block mt-2 font-weight-bold"
                    style={{
                      textDecoration: "none",
                      color: hoverBatal ? "#dc3545" : "#6c757d",
                      transition: "all 0.2s ease-in-out",
                      cursor: "pointer",
                    }}
                    onMouseEnter={() => setHoverBatal(true)}
                    onMouseLeave={() => setHoverBatal(false)}
                    onClick={() => setModalUser(false)}
                  >
                    BATALKAN
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content className="mt-3">
        <Card className="border-0 bg-transparent">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            {/* TOMBOL TAMBAH - Posisi Kiri */}
            <div className="mb-3 mb-md-0">
              <Button
                onClick={() => setModalUser(!modalUser)}
                className="btn-fill d-flex align-items-center shadow-sm"
                style={{
                  backgroundColor: "#1D3557",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px 24px",
                  fontWeight: "600",
                }}
              >
                <i className="nc-icon nc-simple-add mr-2"></i>
                <span>Tambah User</span>
              </Button>
            </div>

            {/* SEARCH BAR - Posisi Kanan dengan Kontras Lebih Tinggi */}
            <div style={{ width: "100%", maxWidth: "350px" }}>
              <InputGroup
                className="shadow-sm"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: "1px solid #ced4da", // Border luar agar bentuknya kelihatan
                }}
              >
                <InputGroup.Text
                  className="border-0"
                  style={{ backgroundColor: "#f8f9fa" }} // Background abu-abu muda
                >
                  <i
                    className="nc-icon nc-zoom-split text-dark"
                    style={{ fontWeight: "bold" }}
                  ></i>
                </InputGroup.Text>
                <Form.Control
                  className="border-0"
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari No. Karyawan / Nama..."
                  style={{
                    height: "45px",
                    backgroundColor: "#f8f9fa", // Senada dengan icon
                    boxShadow: "none",
                    fontSize: "0.95rem",
                    color: "#333",
                  }}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </Tab.Content>

      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "12px", overflow: "hidden" }}
      >
        <DataTable
          columns={colUser}
          data={listUser.filter(
            (row) =>
              row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
              row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
          )}
          customStyles={customStyles}
          pagination
          paginationPerPage={itemsPerPage}
          onChangePage={handlePageChange}
          responsive
          highlightOnHover
        />
      </Card>
    </>
  );
}

export default ListUser;
